import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(Router)

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

// 防止连续点击多次路由报错
let routerReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const context = require.context('.', false, /\.js$/)
let configRoutes = []

context.keys().forEach((key) => {
  if (key === './router.js') return
  configRoutes = configRoutes.concat(context(key).default)
})

const routes = [...configRoutes]


const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes
})

// 页面白名单
const whiteList = [
  '/login',
  '/findpassword',
  '/unipass'
]

// 检查地址白名单
function checkWhite(url) {
  const path = url.split('?')[0]
  return whiteList.indexOf(path) !== -1
}
// router.beforeEach((to, from, next) => {
//   if (!getToken() && !checkWhite(to.path) && to.path != from.path) {
//     router.replace('/login')
//   }
//   next()
// })
router.afterEach((route) => {
  const routeName = route.name || 'empty'
  const { title = '' } = route.meta ? route.meta : {}
  document.title = title || '红山区教育一站通统一认证平台'
})


export default router
